import React from 'react';
import { useNavigate } from 'react-router-dom';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';

export default function ActiveProjectsOverview({ projects, title = "Active Projects Overview" }) {
    const navigate = useNavigate();

    const getProgressColor = (status) => {
        if (status >= 100) return '#4caf50';
        if (status >= 70) return '#8bc34a';
        if (status >= 40) return '#c9a227';
        return '#ff9800';
    };

    if (!projects || projects.length === 0) {
        return (
            <div className="dashboard_section">
                <div className="section_header">
                    <h3><TrendingUpIcon /> {title}</h3>
                </div>
                <div className="empty_state small">
                    <WorkOutlineIcon className="empty_icon" />
                    <p>No active projects yet.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="dashboard_section">
            <div className="section_header">
                <h3><TrendingUpIcon /> {title}</h3>
            </div>
            <div className="active_projects_list">
                {projects.map((project) => (
                    <div 
                        key={project.id} 
                        className="active_project_item"
                        onClick={() => navigate(`/project-details/${project.id}/true`)}
                    >
                        <div className="project_info">
                            <h4 className="project_name">
                                {project.project_name.length > 40 
                                    ? `${project.project_name.slice(0, 40)}...` 
                                    : project.project_name}
                            </h4>
                            {project.assign_to && (
                                <span className="contractor_name">
                                    {project.assign_to.company_name || `${project.assign_to.fname} ${project.assign_to.lname}`}
                                </span>
                            )}
                            {project.user && (
                                <span className="contractor_name">
                                    {project.user.company_name || `${project.user.fname} ${project.user.lname}`}
                                </span>
                            )}
                        </div>
                        <div className="project_progress">
                            <div className="progress_info">
                                <span 
                                    className="progress_percentage"
                                    style={{ color: getProgressColor(project.job_status || 0) }}
                                >
                                    {project.job_status || 0}%
                                </span>
                            </div>
                            <div className="progress_bar_mini">
                                <div 
                                    className="progress_bar_fill_mini"
                                    style={{ 
                                        width: `${project.job_status || 0}%`,
                                        backgroundColor: getProgressColor(project.job_status || 0)
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
